module.exports = __webpack_public_path__ + "static/media/IMG_1706.40c5fd2c.jpg";